import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircle, CheckCircleOutlineOutlined, FlagOutlined, ModeCommentOutlined } from "sprout-ui-icons";
import { Flex, Text } from "sprout-ui-primitives";
import styled, { css } from "styled-components";
import { media, themeGet } from "sprout-ui-theme";
import { useDeadlineDetails } from "sprout-ui-dom";
import Avatar from "../Avatar";
const PostIndicatorsNumText = styled(Text).attrs({
    as: "span",
    color: "black.60",
    fontSize: 1
})`
  font-variant: tabular-nums;
  font-feature-settings: "tnum";
`;
const PostIndicatorsWrapper = styled(Flex)`
  ${({ variant  })=>variant === "solo" ? css`
          ${media.up("medium")} {
            display: none;
          }
        ` : css`
          flex: none;
          ${media.down("medium")} {
            display: none;
          }
        `}

  > * + * {
    margin-left: 8px;
  }
`;
const PostIndicatorsAssignmentsWrapper = styled(Flex)`
  > * {
    border: 1px solid ${themeGet("colors.white.100")};

    + * {
      margin-left: -6px;
    }
  }
`;
const PostIndicators = (props)=>{
    const { checklistsCount , commentCount , variant , assignees , deadline  } = props;
    const isSolo = variant === "solo";
    const deadlineDetails = useDeadlineDetails(deadline);
    return /*#__PURE__*/ _jsxs(PostIndicatorsWrapper, {
        height: "24px",
        alignItems: "center",
        variant: variant,
        mt: isSolo ? 3 : undefined,
        ml: isSolo ? undefined : "auto",
        pl: isSolo ? undefined : 3,
        children: [
            checklistsCount.total > 0 && /*#__PURE__*/ _jsxs(Flex, {
                display: "inline-flex",
                as: "span",
                alignItems: "center",
                color: "#51c65b",
                children: [
                    checklistsCount.completed === checklistsCount.total ? /*#__PURE__*/ _jsx(CheckCircle, {}) : /*#__PURE__*/ _jsx(CheckCircleOutlineOutlined, {}),
                    /*#__PURE__*/ _jsx(PostIndicatorsNumText, {
                        ml: 0,
                        children: `${checklistsCount.completed}/${checklistsCount.total}`
                    })
                ]
            }),
            commentCount > 0 && /*#__PURE__*/ _jsxs(Flex, {
                display: "inline-flex",
                as: "span",
                alignItems: "center",
                color: "black.60",
                children: [
                    /*#__PURE__*/ _jsx(ModeCommentOutlined, {}),
                    /*#__PURE__*/ _jsx(PostIndicatorsNumText, {
                        ml: 0,
                        children: commentCount
                    })
                ]
            }),
            assignees.length > 0 && /*#__PURE__*/ _jsx(PostIndicatorsAssignmentsWrapper, {
                alignItems: "center",
                justifyContent: "center",
                children: assignees.map((user)=>/*#__PURE__*/ _jsx(Avatar, {
                        user: user,
                        size: 24
                    }, user.id))
            }),
            deadlineDetails && /*#__PURE__*/ _jsxs(Flex, {
                display: "inline-flex",
                as: "span",
                alignItems: "center",
                color: deadlineDetails.moreThan7Days ? "black.60" : "#ff1744",
                children: [
                    /*#__PURE__*/ _jsx(FlagOutlined, {}),
                    /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        fontSize: 1,
                        ml: 0,
                        children: deadlineDetails.label
                    })
                ]
            })
        ]
    });
};
export default PostIndicators;
